
import { Button } from "@dub/ui";

export type SortKey = string;
export type Sort = { key: SortKey; dir: "asc" | "desc" };

export const SortHeader = ({
  label,
  sortKey,
  sort,
  setSort,
  align = "left",
}: {
  label: string;
  sortKey: SortKey;
  sort: Sort;
  setSort: (s: Sort) => void;
  align?: "left" | "right" | "center";
}) => {
  const isActive = sort.key === sortKey;
  const nextDir = isActive && sort.dir === "asc" ? "desc" : "asc";
  return (
    <Button
      variant="ghost"
      onClick={() => setSort({ key: sortKey, dir: nextDir })}
      className={`w-full text-[12px] uppercase tracking-wider text-neutral-600 hover:text-black flex items-center gap-1 h-auto py-0 px-0 hover:bg-transparent ${
        align === "right" ? "justify-end" : align === "center" ? "justify-center" : "justify-start"
      }`}
      title={`Sort by ${label}`}
    >
      {label}
      <span className={`text-neutral-400 ${isActive ? "opacity-100" : "opacity-0"}`}>
        {sort.dir === "asc" ? "▲" : "▼"}
      </span>
    </Button>
  );
};

